import { useEffect } from "react";
import { convertToFilter, makeObservable } from "../../../util";
import {
  createFilterFormStore,
  usePersistedFilterFormik,
} from "../../../util/usePersistedFilterFormik";
import { createSearchResultNavigationStore } from "../../../util/searchResultNavigation";

const artistFilterStore = makeObservable({});
const artistNavigationStore =
  createSearchResultNavigationStore(artistFilterStore);

const toArtistFilter = values =>
  convertToFilter({ values, filterKeys: [], skipKeys: ["limit", "offset"] });

const filterFormStore = createFilterFormStore(
  "artist",
  artistFilterStore,
  artistNavigationStore,
  { toFilter: toArtistFilter },
);

const useArtistFilters = () => {
  const formik = usePersistedFilterFormik(
    {
      initialValues: {
        limit: 50,
        represented: { operator: "in" },
      },
    },
    filterFormStore,
  );

  useEffect(() => {
    artistFilterStore.set(toArtistFilter(formik.values));
  }, [formik.values]);

  return {
    formik,
  };
};

export { artistFilterStore, artistNavigationStore, useArtistFilters };
